import React, { Component } from 'react'

import {RadioGroup, Radio} from 'react-radio-group'
import 'react-select/dist/react-select.css';

const style = {
	backgroundColor: '#fff'
}
export default props => (
	<div>
	  <RadioGroup
	    name={props.input.name}
	    selectedValue={props.input.selectedValue}
	    onChange={props.input.onChange}>
	    <Radio value="union" />Union
	    <Radio value="non-union" />Non-Union
	  </RadioGroup>
	  { (props.meta.touched && props.meta.error) && <span className="form-error is-visible" id="uuid">{props.meta.error}</span> }
	</div>
)


// WEBPACK FOOTER //
// ./src/components/ui/RadioGroupComponent.js